import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../api';
import { formatDate, Page, State } from '../components';
interface Member {
  id: string;
  role: string;
  createdAt: string;
  user: { displayName: string; email: string };
}
export function MembersPage() {
  const client = useQueryClient();
  const query = useQuery({
    queryKey: ['members'],
    queryFn: () => api<{ data: Member[] }>('/api/v1/members'),
  });
  const update = useMutation({
    mutationFn: ({ id, role }: { id: string; role: string }) =>
      api(`/api/v1/members/${id}/role`, { method: 'PATCH', body: JSON.stringify({ role }) }),
    onSuccess: () => void client.invalidateQueries({ queryKey: ['members'] }),
  });
  return (
    <Page
      title="Tenant members"
      description="Fixed roles keep authorization understandable. The final owner cannot be demoted."
    >
      <State loading={query.isLoading} error={query.error} empty={query.data?.data.length === 0}>
        <div className="card table-scroll">
          <table>
            <thead>
              <tr>
                <th>Member</th>
                <th>Email</th>
                <th>Joined</th>
                <th>Role</th>
              </tr>
            </thead>
            <tbody>
              {query.data?.data.map((row) => (
                <tr key={row.id}>
                  <td>{row.user.displayName}</td>
                  <td>{row.user.email}</td>
                  <td>{formatDate(row.createdAt)}</td>
                  <td>
                    <select
                      aria-label={`Role for ${row.user.displayName}`}
                      value={row.role}
                      onChange={(e) => update.mutate({ id: row.id, role: e.target.value })}
                    >
                      <option>OWNER</option>
                      <option>ADMIN</option>
                      <option>AGENT</option>
                      <option>VIEWER</option>
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {update.error && <p className="form-error">{update.error.message}</p>}
        </div>
      </State>
    </Page>
  );
}
